/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Ashish Singh, Created Date: 29-August-2023
</summary>
*/


import { IAddTreatmentManagement } from "../../models/forms/IAddTreatment";


export const initialState: IAddTreatmentManagement = {
    RegistrationType: 0,
    BusinessTypeId: -1,
    CategoryId: -1,
    CategoryPath: "",
    IsReservationSite: true,
    TreatmentName: "",
    Time: -1,
    TimeValue: 0,
    FeeExcludingTax: '',
    TaxId: -1,
    TaxValue: 0,
    StartDate: "",
    EndDate: "",
    Status: '0',
    Note: "",
    OptionMenu: '1',
    TaxAmount: '',
    FeeIncludingTax: "",
    Description: '',
    StoreId: null,
    IsFeatured: false,
    Image: "",
    StaffOptions: [],
    IsAutoCalculateTax: true
}